import React from 'react';
import SystemContext from './systemContext';
import Swal from 'sweetalert2';

class SystemState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.getStoredUser() || {}, // Cargar usuario almacenado
      token: this.getStoredToken() || ""
    };
  }

  // Obtener usuario del localStorage
  getStoredUser = () => {
    try {
      const userInfo = localStorage.getItem('user_vsc');
      return userInfo ? JSON.parse(userInfo) : null;
    } catch (error) {
      console.error('Error obteniendo usuario almacenado:', error);
      return null;
    }
  }

  // Obtener token del localStorage
  getStoredToken = () => {
    const user = this.getStoredUser();
    return user?.token || "";
  }

  setUser = async (data) => {
    try {
      console.log('🔧 SystemState.setUser llamado:', data ? data.email : 'null');
      
      if (data) {
        // Validar datos mínimos
        if (!data.email) {
          console.warn('⚠️ setUser llamado sin email');
          return;
        }        
        // Guardar en localStorage
        localStorage.setItem('user_vsc', JSON.stringify(data));        
        // Actualizar estado
        this.setState({
          user: data,
          token: data.token || 'msal-authenticated'
        });        
        console.log('✅ Usuario guardado en SystemState:', data.email);
      } else {
        // Limpiar datos
        localStorage.removeItem('user_vsc');
        this.setState({
          user: {},
          token: ""
        });
        console.log('✅ SystemState limpiado');
      }
    } catch (error) {
      console.error('🚨 Error en SystemState.setUser:', error);
      Swal.fire({
        title: "Error",
        html: `Error al procesar usuario.`,
        icon: "error"
      });
    }
  }

  // Método mejorado para obtener usuario
  getUser = () => {
    try {
      // Primero verificar estado actual
      if (this.state.user && this.state.user.id !== undefined) {
        return this.state.user;
      }
      
      // Si no, intentar desde localStorage
      const storedUser = this.getStoredUser();
      if (storedUser) {
        // Sincronizar estado
        this.setState({ user: storedUser });
        return storedUser;
      }
      
      return null;
    } catch (err) {
      console.error('Error obteniendo usuario:', err);
      // Limpiar datos corruptos
      localStorage.removeItem('user_vsc');
      this.setState({ user: {}, token: "" });
      return null;
    }
  };

  getToken = () => {
    return this.state.token || this.getStoredToken();
  }

  logout = () => {
    console.log('👋 SystemState.logout llamado');
    
    // Limpiar almacenamiento
    localStorage.removeItem("user_vsc");
    
    // Resetear estado
    this.setState({
      user: {},
      token: ""
    }, () => {
      // Redirigir después de actualizar estado
      console.log('🔄 Redirigiendo a inicio...');
      window.location.href = "/";
    });
  }

  // 🔴 Agregar método para verificar si hay sesión activa
  isLoggedIn = () => {
    const user = this.getUser();
    return !!(user && user.email);
  }

  render() {
    const contextValue = {
      user: this.state.user,
      token: this.state.token,
      setUser: this.setUser,
      getUser: this.getUser,
      getToken: this.getToken,
      logout: this.logout,
      isLoggedIn: this.isLoggedIn
    };

    console.log('🎯 SystemState render:', { 
      hasUser: !!this.state.user.email,
      userEmail: this.state.user.email 
    });

    return (
      <SystemContext.Provider value={contextValue}>
        {this.props.children}
      </SystemContext.Provider>
    );
  }  
};

export default SystemState;